import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';

const ACTION_ITEM_ICON_CLASS = 'layout-action-menu-item-icon';

/**
 * Renders dropdown menu items from a generic items array.
 * Used by both MobileActionMenu and DesktopActionMenu.
 */
export const renderActionMenuItems = (items) => {
  if (!items || !items.length) return null;
  return items.map((item, index) => {
    if (item.divider) {
      return <Dropdown.Divider key={`divider-${index}`} />;
    }
    if (item.to) {
      const to = typeof item.to === 'string' ? { pathname: item.to } : item.to;
      return (
        <Dropdown.Item key={`item-${index}`} as={Link} to={to}>
          {item.icon ? (
            <img src={item.icon} alt="" className={`mr-2 ${ACTION_ITEM_ICON_CLASS}`} />
          ) : null}
          {item.label}
        </Dropdown.Item>
      );
    }
    return (
      <Dropdown.Item key={`item-${index}`} onClick={item.onClick}>
        {item.icon ? (
          <img src={item.icon} alt="" className={`mr-2 ${ACTION_ITEM_ICON_CLASS}`} />
        ) : null}
        {item.label}
      </Dropdown.Item>
    );
  });
};
